module.exports = __webpack_public_path__ + "img/connector-types-fr.2432323e.webp";